@file:OptIn(InternalResourceApi::class)

package top.clientapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/top.clientapp.generated.resources/"

@delegate:ResourceContentHash(-728_830_615)
internal val Res.string.auth_already_have_account: StringResource by lazy {
      StringResource("string:auth_already_have_account", "auth_already_have_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 97),
      ))
    }

@delegate:ResourceContentHash(313_572_683)
internal val Res.string.auth_continue_without_account: StringResource by lazy {
      StringResource("string:auth_continue_without_account", "auth_continue_without_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108, 93),
      ))
    }

@delegate:ResourceContentHash(-1_713_180_008)
internal val Res.string.auth_email_label: StringResource by lazy {
      StringResource("string:auth_email_label", "auth_email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202, 32),
      ))
    }

@delegate:ResourceContentHash(763_331_642)
internal val Res.string.auth_email_placeholder: StringResource by lazy {
      StringResource("string:auth_email_placeholder", "auth_email_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 235, 58),
      ))
    }

@delegate:ResourceContentHash(1_437_946_615)
internal val Res.string.auth_error_check_data: StringResource by lazy {
      StringResource("string:auth_error_check_data", "auth_error_check_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 294, 65),
      ))
    }

@delegate:ResourceContentHash(199_346_634)
internal val Res.string.auth_error_enter_first_name: StringResource by lazy {
      StringResource("string:auth_error_enter_first_name", "auth_error_enter_first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 360, 67),
      ))
    }

@delegate:ResourceContentHash(-2_028_818_851)
internal val Res.string.auth_error_enter_last_name: StringResource by lazy {
      StringResource("string:auth_error_enter_last_name", "auth_error_enter_last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 428, 78),
      ))
    }

@delegate:ResourceContentHash(-1_455_101_709)
internal val Res.string.auth_error_enter_phone: StringResource by lazy {
      StringResource("string:auth_error_enter_phone", "auth_error_enter_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 507, 86),
      ))
    }

@delegate:ResourceContentHash(-665_181_070)
internal val Res.string.auth_error_invalid_code: StringResource by lazy {
      StringResource("string:auth_error_invalid_code", "auth_error_invalid_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 594, 63),
      ))
    }

@delegate:ResourceContentHash(962_920_847)
internal val Res.string.auth_error_invalid_email: StringResource by lazy {
      StringResource("string:auth_error_invalid_email", "auth_error_invalid_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 658, 72),
      ))
    }

@delegate:ResourceContentHash(-887_415_876)
internal val Res.string.auth_error_invalid_phone: StringResource by lazy {
      StringResource("string:auth_error_invalid_phone", "auth_error_invalid_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 731, 96),
      ))
    }

@delegate:ResourceContentHash(-169_808_203)
internal val Res.string.auth_error_login_failed: StringResource by lazy {
      StringResource("string:auth_error_login_failed", "auth_error_login_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 828, 75),
      ))
    }

@delegate:ResourceContentHash(1_260_338_738)
internal val Res.string.auth_error_registration_failed: StringResource by lazy {
      StringResource("string:auth_error_registration_failed", "auth_error_registration_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 904, 106),
      ))
    }

@delegate:ResourceContentHash(-1_481_385_214)
internal val Res.string.auth_error_resend_failed: StringResource by lazy {
      StringResource("string:auth_error_resend_failed", "auth_error_resend_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1011, 116),
      ))
    }

@delegate:ResourceContentHash(-480_980_300)
internal val Res.string.auth_first_name_label: StringResource by lazy {
      StringResource("string:auth_first_name_label", "auth_first_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1128, 41),
      ))
    }

@delegate:ResourceContentHash(2_125_539_842)
internal val Res.string.auth_first_name_placeholder: StringResource by lazy {
      StringResource("string:auth_first_name_placeholder", "auth_first_name_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1170, 51),
      ))
    }

@delegate:ResourceContentHash(1_627_068_818)
internal val Res.string.auth_get_started_description: StringResource by lazy {
      StringResource("string:auth_get_started_description", "auth_get_started_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1222, 240),
      ))
    }

@delegate:ResourceContentHash(-1_979_028_267)
internal val Res.string.auth_get_started_title: StringResource by lazy {
      StringResource("string:auth_get_started_title", "auth_get_started_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1463, 74),
      ))
    }

@delegate:ResourceContentHash(1_055_236_886)
internal val Res.string.auth_last_name_label: StringResource by lazy {
      StringResource("string:auth_last_name_label", "auth_last_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1538, 52),
      ))
    }

@delegate:ResourceContentHash(-2_083_774_096)
internal val Res.string.auth_last_name_placeholder: StringResource by lazy {
      StringResource("string:auth_last_name_placeholder", "auth_last_name_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1591, 46),
      ))
    }

@delegate:ResourceContentHash(-1_435_543_509)
internal val Res.string.auth_login_action: StringResource by lazy {
      StringResource("string:auth_login_action", "auth_login_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1638, 41),
      ))
    }

@delegate:ResourceContentHash(648_571_217)
internal val Res.string.auth_login_by_phone: StringResource by lazy {
      StringResource("string:auth_login_by_phone", "auth_login_by_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1680, 95),
      ))
    }

@delegate:ResourceContentHash(1_820_741_202)
internal val Res.string.auth_login_subtitle: StringResource by lazy {
      StringResource("string:auth_login_subtitle", "auth_login_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1776, 63),
      ))
    }

@delegate:ResourceContentHash(-1_435_543_509)
internal val Res.string.auth_login_title: StringResource by lazy {
      StringResource("string:auth_login_title", "auth_login_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1840, 40),
      ))
    }

@delegate:ResourceContentHash(1_962_512_428)
internal val Res.string.auth_phone_label: StringResource by lazy {
      StringResource("string:auth_phone_label", "auth_phone_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1881, 60),
      ))
    }

@delegate:ResourceContentHash(-766_429_889)
internal val Res.string.auth_phone_placeholder: StringResource by lazy {
      StringResource("string:auth_phone_placeholder", "auth_phone_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1942, 54),
      ))
    }

@delegate:ResourceContentHash(1_496_395_519)
internal val Res.string.auth_register_action: StringResource by lazy {
      StringResource("string:auth_register_action", "auth_register_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1997, 68),
      ))
    }

@delegate:ResourceContentHash(1_402_360_488)
internal val Res.string.auth_register_by_phone: StringResource by lazy {
      StringResource("string:auth_register_by_phone", "auth_register_by_phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2066, 122),
      ))
    }

@delegate:ResourceContentHash(-398_167_867)
internal val Res.string.auth_register_subtitle: StringResource by lazy {
      StringResource("string:auth_register_subtitle", "auth_register_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2189, 106),
      ))
    }

@delegate:ResourceContentHash(1_496_395_522)
internal val Res.string.auth_register_title: StringResource by lazy {
      StringResource("string:auth_register_title", "auth_register_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2296, 67),
      ))
    }

@delegate:ResourceContentHash(-1_265_751_917)
internal val Res.string.auth_success_description: StringResource by lazy {
      StringResource("string:auth_success_description", "auth_success_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2364, 132),
      ))
    }

@delegate:ResourceContentHash(1_161_503_006)
internal val Res.string.auth_success_title: StringResource by lazy {
      StringResource("string:auth_success_title", "auth_success_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2497, 86),
      ))
    }

@delegate:ResourceContentHash(-1_162_192_216)
internal val Res.string.auth_verify_phone_subtitle: StringResource by lazy {
      StringResource("string:auth_verify_phone_subtitle", "auth_verify_phone_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2584, 226),
      ))
    }

@delegate:ResourceContentHash(-923_452_770)
internal val Res.string.auth_verify_phone_title: StringResource by lazy {
      StringResource("string:auth_verify_phone_title", "auth_verify_phone_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2811, 95),
      ))
    }

@delegate:ResourceContentHash(340_260_747)
internal val Res.string.client_all_categories_title: StringResource by lazy {
      StringResource("string:client_all_categories_title", "client_all_categories_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2907, 71),
      ))
    }

@delegate:ResourceContentHash(408_856_527)
internal val Res.string.client_category_search_placeholder: StringResource by lazy {
      StringResource("string:client_category_search_placeholder", "client_category_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 66, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2979, 98),
      ))
    }

@delegate:ResourceContentHash(1_338_540_076)
internal val Res.string.client_filter_all: StringResource by lazy {
      StringResource("string:client_filter_all", "client_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 141, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3078, 33),
      ))
    }

@delegate:ResourceContentHash(-12_035_752)
internal val Res.string.client_filter_apply: StringResource by lazy {
      StringResource("string:client_filter_apply", "client_filter_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 171, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3112, 79),
      ))
    }

@delegate:ResourceContentHash(664_597_131)
internal val Res.string.client_filter_categories: StringResource by lazy {
      StringResource("string:client_filter_categories", "client_filter_categories", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 219, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3192, 56),
      ))
    }

@delegate:ResourceContentHash(66_240_771)
internal val Res.string.client_filter_close_content_description: StringResource by lazy {
      StringResource("string:client_filter_close_content_description", "client_filter_close_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 268, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3249, 63),
      ))
    }

@delegate:ResourceContentHash(2_055_823_424)
internal val Res.string.client_filter_location: StringResource by lazy {
      StringResource("string:client_filter_location", "client_filter_location", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 474, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3475, 50),
      ))
    }

@delegate:ResourceContentHash(2_122_548_159)
internal val Res.string.client_filter_location_around: StringResource by lazy {
      StringResource("string:client_filter_location_around", "client_filter_location_around", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 324, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3313, 57),
      ))
    }

@delegate:ResourceContentHash(1_561_690_210)
internal val Res.string.client_filter_location_over_40: StringResource by lazy {
      StringResource("string:client_filter_location_over_40", "client_filter_location_over_40", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 370, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3371, 50),
      ))
    }

@delegate:ResourceContentHash(516_189_090)
internal val Res.string.client_filter_location_within_40: StringResource by lazy {
      StringResource("string:client_filter_location_within_40", "client_filter_location_within_40", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 421, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3422, 52),
      ))
    }

@delegate:ResourceContentHash(-164_247_780)
internal val Res.string.client_filter_price_range: StringResource by lazy {
      StringResource("string:client_filter_price_range", "client_filter_price_range", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 517, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3526, 77),
      ))
    }

@delegate:ResourceContentHash(798_338_338)
internal val Res.string.client_filter_rating: StringResource by lazy {
      StringResource("string:client_filter_rating", "client_filter_rating", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 567, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3604, 48),
      ))
    }

@delegate:ResourceContentHash(-1_908_083_808)
internal val Res.string.client_filter_remove_service_content_description: StringResource by lazy {
      StringResource("string:client_filter_remove_service_content_description", "client_filter_remove_service_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 604, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3653, 100),
      ))
    }

@delegate:ResourceContentHash(279_184_373)
internal val Res.string.client_filter_service_search_placeholder: StringResource by lazy {
      StringResource("string:client_filter_service_search_placeholder", "client_filter_service_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 681, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3754, 84),
      ))
    }

@delegate:ResourceContentHash(2_022_026_483)
internal val Res.string.client_filter_services: StringResource by lazy {
      StringResource("string:client_filter_services", "client_filter_services", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 750, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3839, 50),
      ))
    }

@delegate:ResourceContentHash(855_099_901)
internal val Res.string.client_filter_title: StringResource by lazy {
      StringResource("string:client_filter_title", "client_filter_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 793, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3890, 63),
      ))
    }

@delegate:ResourceContentHash(1_904_423_763)
internal val Res.string.client_home_badge_unverified: StringResource by lazy {
      StringResource("string:client_home_badge_unverified", "client_home_badge_unverified", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 841, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3954, 104),
      ))
    }

@delegate:ResourceContentHash(-853_604_079)
internal val Res.string.client_home_badge_verified: StringResource by lazy {
      StringResource("string:client_home_badge_verified", "client_home_badge_verified", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 910, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4059, 94),
      ))
    }

@delegate:ResourceContentHash(985_696_288)
internal val Res.string.client_home_best_week: StringResource by lazy {
      StringResource("string:client_home_best_week", "client_home_best_week", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 973, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4154, 77),
      ))
    }

@delegate:ResourceContentHash(664_597_131)
internal val Res.string.client_home_categories: StringResource by lazy {
      StringResource("string:client_home_categories", "client_home_categories", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1031, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4232, 54),
      ))
    }

@delegate:ResourceContentHash(602_415_315)
internal val Res.string.client_home_category_auto: StringResource by lazy {
      StringResource("string:client_home_category_auto", "client_home_category_auto", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1078, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4287, 45),
      ))
    }

@delegate:ResourceContentHash(1_709_500_334)
internal val Res.string.client_home_category_banks: StringResource by lazy {
      StringResource("string:client_home_category_banks", "client_home_category_banks", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1120, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4333, 50),
      ))
    }

@delegate:ResourceContentHash(-1_887_530_608)
internal val Res.string.client_home_category_beauty: StringResource by lazy {
      StringResource("string:client_home_category_beauty", "client_home_category_beauty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1163, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4384, 51),
      ))
    }

@delegate:ResourceContentHash(1_298_457_235)
internal val Res.string.client_home_category_business: StringResource by lazy {
      StringResource("string:client_home_category_business", "client_home_category_business", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1207, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4436, 53),
      ))
    }

@delegate:ResourceContentHash(1_353_063_818)
internal val Res.string.client_home_category_education: StringResource by lazy {
      StringResource("string:client_home_category_education", "client_home_category_education", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1257, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4490, 54),
      ))
    }

@delegate:ResourceContentHash(1_019_612_960)
internal val Res.string.client_home_category_events: StringResource by lazy {
      StringResource("string:client_home_category_events", "client_home_category_events", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1308, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4545, 51),
      ))
    }

@delegate:ResourceContentHash(-1_860_766_343)
internal val Res.string.client_home_category_food: StringResource by lazy {
      StringResource("string:client_home_category_food", "client_home_category_food", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1352, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4597, 41),
      ))
    }

@delegate:ResourceContentHash(816_516_352)
internal val Res.string.client_home_category_health: StringResource by lazy {
      StringResource("string:client_home_category_health", "client_home_category_health", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1394, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4639, 55),
      ))
    }

@delegate:ResourceContentHash(-859_454_353)
internal val Res.string.client_home_category_home: StringResource by lazy {
      StringResource("string:client_home_category_home", "client_home_category_home", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1438, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4695, 41),
      ))
    }

@delegate:ResourceContentHash(1_891_067_973)
internal val Res.string.client_home_category_household: StringResource by lazy {
      StringResource("string:client_home_category_household", "client_home_category_household", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1480, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4737, 54),
      ))
    }

@delegate:ResourceContentHash(81_851_872)
internal val Res.string.client_home_category_it_media: StringResource by lazy {
      StringResource("string:client_home_category_it_media", "client_home_category_it_media", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1531, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4792, 41),
      ))
    }

@delegate:ResourceContentHash(1_996_338_528)
internal val Res.string.client_home_category_logistics: StringResource by lazy {
      StringResource("string:client_home_category_logistics", "client_home_category_logistics", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1573, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4834, 62),
      ))
    }

@delegate:ResourceContentHash(-1_262_995_133)
internal val Res.string.client_home_category_malls: StringResource by lazy {
      StringResource("string:client_home_category_malls", "client_home_category_malls", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1624, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4897, 42),
      ))
    }

@delegate:ResourceContentHash(820_803_306)
internal val Res.string.client_home_category_markets: StringResource by lazy {
      StringResource("string:client_home_category_markets", "client_home_category_markets", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1667, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4940, 56),
      ))
    }

@delegate:ResourceContentHash(-823_686_740)
internal val Res.string.client_home_category_pets: StringResource by lazy {
      StringResource("string:client_home_category_pets", "client_home_category_pets", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1716, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4997, 53),
      ))
    }

@delegate:ResourceContentHash(-1_480_629_612)
internal val Res.string.client_home_category_travel: StringResource by lazy {
      StringResource("string:client_home_category_travel", "client_home_category_travel", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1758, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5051, 51),
      ))
    }

@delegate:ResourceContentHash(-1_673_446_733)
internal val Res.string.client_home_empty_description: StringResource by lazy {
      StringResource("string:client_home_empty_description", "client_home_empty_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1802, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5103, 133),
      ))
    }

@delegate:ResourceContentHash(-1_617_976_622)
internal val Res.string.client_home_empty_title: StringResource by lazy {
      StringResource("string:client_home_empty_title", "client_home_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1884, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5237, 79),
      ))
    }

@delegate:ResourceContentHash(835_982_247)
internal val Res.string.client_home_favorite_content_description: StringResource by lazy {
      StringResource("string:client_home_favorite_content_description", "client_home_favorite_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1936, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5317, 88),
      ))
    }

@delegate:ResourceContentHash(684_868_501)
internal val Res.string.client_home_filter_content_description: StringResource by lazy {
      StringResource("string:client_home_filter_content_description", "client_home_filter_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2001, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5406, 62),
      ))
    }

@delegate:ResourceContentHash(-1_475_836_407)
internal val Res.string.client_home_load_error_title: StringResource by lazy {
      StringResource("string:client_home_load_error_title", "client_home_load_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2056, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5469, 112),
      ))
    }

@delegate:ResourceContentHash(501_841_100)
internal val Res.string.client_home_location_city: StringResource by lazy {
      StringResource("string:client_home_location_city", "client_home_location_city", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2121, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5582, 45),
      ))
    }

@delegate:ResourceContentHash(71_461_854)
internal val Res.string.client_home_notifications_content_description: StringResource by lazy {
      StringResource("string:client_home_notifications_content_description", "client_home_notifications_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2163, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5628, 81),
      ))
    }

@delegate:ResourceContentHash(-2_083_026_991)
internal val Res.string.client_home_search_placeholder: StringResource by lazy {
      StringResource("string:client_home_search_placeholder", "client_home_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2237, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5710, 74),
      ))
    }

@delegate:ResourceContentHash(-987_507_858)
internal val Res.string.client_home_view_all: StringResource by lazy {
      StringResource("string:client_home_view_all", "client_home_view_all", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2296, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5785, 60),
      ))
    }

@delegate:ResourceContentHash(66_240_771)
internal val Res.string.client_location_search_back_content_description: StringResource by lazy {
      StringResource("string:client_location_search_back_content_description", "client_location_search_back_content_description", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2337, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5846, 71),
      ))
    }

@delegate:ResourceContentHash(-1_658_954_262)
internal val Res.string.client_location_search_empty: StringResource by lazy {
      StringResource("string:client_location_search_empty", "client_location_search_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2401, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5918, 84),
      ))
    }

@delegate:ResourceContentHash(1_844_942_266)
internal val Res.string.client_location_search_placeholder: StringResource by lazy {
      StringResource("string:client_location_search_placeholder", "client_location_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2458, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6003, 98),
      ))
    }

@delegate:ResourceContentHash(225_451_480)
internal val Res.string.client_location_search_title: StringResource by lazy {
      StringResource("string:client_location_search_title", "client_location_search_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2533, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6102, 76),
      ))
    }

@delegate:ResourceContentHash(1_495_262_358)
internal val Res.string.client_map_empty_title: StringResource by lazy {
      StringResource("string:client_map_empty_title", "client_map_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6179, 102),
      ))
    }

@delegate:ResourceContentHash(-441_402_377)
internal val Res.string.client_map_load_error: StringResource by lazy {
      StringResource("string:client_map_load_error", "client_map_load_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6282, 129),
      ))
    }

@delegate:ResourceContentHash(2_135_735_473)
internal val Res.string.client_map_loading: StringResource by lazy {
      StringResource("string:client_map_loading", "client_map_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6412, 58),
      ))
    }

@delegate:ResourceContentHash(80_031_496)
internal val Res.string.client_map_results_count: StringResource by lazy {
      StringResource("string:client_map_results_count", "client_map_results_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6471, 84),
      ))
    }

@delegate:ResourceContentHash(-1_919_424_238)
internal val Res.string.client_map_search_placeholder: StringResource by lazy {
      StringResource("string:client_map_search_placeholder", "client_map_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6556, 93),
      ))
    }

@delegate:ResourceContentHash(-701_350_731)
internal val Res.string.client_profile_app_version_prefix: StringResource by lazy {
      StringResource("string:client_profile_app_version_prefix", "client_profile_app_version_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2590, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6650, 57),
      ))
    }

@delegate:ResourceContentHash(-6_449_997)
internal val Res.string.client_profile_auth_required_message: StringResource by lazy {
      StringResource("string:client_profile_auth_required_message", "client_profile_auth_required_message", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2644, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6708, 216),
      ))
    }

@delegate:ResourceContentHash(676_065_620)
internal val Res.string.client_profile_auth_required_title: StringResource by lazy {
      StringResource("string:client_profile_auth_required_title", "client_profile_auth_required_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2769, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6925, 78),
      ))
    }

@delegate:ResourceContentHash(-725_032_592)
internal val Res.string.client_profile_avatar_upload_error: StringResource by lazy {
      StringResource("string:client_profile_avatar_upload_error", "client_profile_avatar_upload_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2836, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7004, 110),
      ))
    }

@delegate:ResourceContentHash(12_648_296)
internal val Res.string.client_profile_change_photo: StringResource by lazy {
      StringResource("string:client_profile_change_photo", "client_profile_change_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2911, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7115, 67),
      ))
    }

@delegate:ResourceContentHash(-624_347_372)
internal val Res.string.client_profile_contact_description_label: StringResource by lazy {
      StringResource("string:client_profile_contact_description_label", "client_profile_contact_description_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 2963, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7183, 60),
      ))
    }

@delegate:ResourceContentHash(869_245_339)
internal val Res.string.client_profile_contact_description_placeholder: StringResource by lazy {
      StringResource("string:client_profile_contact_description_placeholder", "client_profile_contact_description_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3028, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7244, 126),
      ))
    }

@delegate:ResourceContentHash(-1_519_396_547)
internal val Res.string.client_profile_contact_error: StringResource by lazy {
      StringResource("string:client_profile_contact_error", "client_profile_contact_error", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3127, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7371, 112),
      ))
    }

@delegate:ResourceContentHash(-1_967_369_073)
internal val Res.string.client_profile_contact_subject_label: StringResource by lazy {
      StringResource("string:client_profile_contact_subject_label", "client_profile_contact_subject_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3196, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7484, 56),
      ))
    }

@delegate:ResourceContentHash(1_466_588_137)
internal val Res.string.client_profile_contact_subject_placeholder: StringResource by lazy {
      StringResource("string:client_profile_contact_subject_placeholder", "client_profile_contact_subject_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3253, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7541, 74),
      ))
    }

@delegate:ResourceContentHash(1_742_274_547)
internal val Res.string.client_profile_contact_success: StringResource by lazy {
      StringResource("string:client_profile_contact_success", "client_profile_contact_success", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3312, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7616, 90),
      ))
    }

@delegate:ResourceContentHash(-321_999_190)
internal val Res.string.client_profile_contact_us: StringResource by lazy {
      StringResource("string:client_profile_contact_us", "client_profile_contact_us", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 3367, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7707, 77),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("auth_already_have_account", Res.string.auth_already_have_account)
  map.put("auth_continue_without_account", Res.string.auth_continue_without_account)
  map.put("auth_email_label", Res.string.auth_email_label)
  map.put("auth_email_placeholder", Res.string.auth_email_placeholder)
  map.put("auth_error_check_data", Res.string.auth_error_check_data)
  map.put("auth_error_enter_first_name", Res.string.auth_error_enter_first_name)
  map.put("auth_error_enter_last_name", Res.string.auth_error_enter_last_name)
  map.put("auth_error_enter_phone", Res.string.auth_error_enter_phone)
  map.put("auth_error_invalid_code", Res.string.auth_error_invalid_code)
  map.put("auth_error_invalid_email", Res.string.auth_error_invalid_email)
  map.put("auth_error_invalid_phone", Res.string.auth_error_invalid_phone)
  map.put("auth_error_login_failed", Res.string.auth_error_login_failed)
  map.put("auth_error_registration_failed", Res.string.auth_error_registration_failed)
  map.put("auth_error_resend_failed", Res.string.auth_error_resend_failed)
  map.put("auth_first_name_label", Res.string.auth_first_name_label)
  map.put("auth_first_name_placeholder", Res.string.auth_first_name_placeholder)
  map.put("auth_get_started_description", Res.string.auth_get_started_description)
  map.put("auth_get_started_title", Res.string.auth_get_started_title)
  map.put("auth_last_name_label", Res.string.auth_last_name_label)
  map.put("auth_last_name_placeholder", Res.string.auth_last_name_placeholder)
  map.put("auth_login_action", Res.string.auth_login_action)
  map.put("auth_login_by_phone", Res.string.auth_login_by_phone)
  map.put("auth_login_subtitle", Res.string.auth_login_subtitle)
  map.put("auth_login_title", Res.string.auth_login_title)
  map.put("auth_phone_label", Res.string.auth_phone_label)
  map.put("auth_phone_placeholder", Res.string.auth_phone_placeholder)
  map.put("auth_register_action", Res.string.auth_register_action)
  map.put("auth_register_by_phone", Res.string.auth_register_by_phone)
  map.put("auth_register_subtitle", Res.string.auth_register_subtitle)
  map.put("auth_register_title", Res.string.auth_register_title)
  map.put("auth_success_description", Res.string.auth_success_description)
  map.put("auth_success_title", Res.string.auth_success_title)
  map.put("auth_verify_phone_subtitle", Res.string.auth_verify_phone_subtitle)
  map.put("auth_verify_phone_title", Res.string.auth_verify_phone_title)
  map.put("client_all_categories_title", Res.string.client_all_categories_title)
  map.put("client_category_search_placeholder", Res.string.client_category_search_placeholder)
  map.put("client_filter_all", Res.string.client_filter_all)
  map.put("client_filter_apply", Res.string.client_filter_apply)
  map.put("client_filter_categories", Res.string.client_filter_categories)
  map.put("client_filter_close_content_description", Res.string.client_filter_close_content_description)
  map.put("client_filter_location", Res.string.client_filter_location)
  map.put("client_filter_location_around", Res.string.client_filter_location_around)
  map.put("client_filter_location_over_40", Res.string.client_filter_location_over_40)
  map.put("client_filter_location_within_40", Res.string.client_filter_location_within_40)
  map.put("client_filter_price_range", Res.string.client_filter_price_range)
  map.put("client_filter_rating", Res.string.client_filter_rating)
  map.put("client_filter_remove_service_content_description", Res.string.client_filter_remove_service_content_description)
  map.put("client_filter_service_search_placeholder", Res.string.client_filter_service_search_placeholder)
  map.put("client_filter_services", Res.string.client_filter_services)
  map.put("client_filter_title", Res.string.client_filter_title)
  map.put("client_home_badge_unverified", Res.string.client_home_badge_unverified)
  map.put("client_home_badge_verified", Res.string.client_home_badge_verified)
  map.put("client_home_best_week", Res.string.client_home_best_week)
  map.put("client_home_categories", Res.string.client_home_categories)
  map.put("client_home_category_auto", Res.string.client_home_category_auto)
  map.put("client_home_category_banks", Res.string.client_home_category_banks)
  map.put("client_home_category_beauty", Res.string.client_home_category_beauty)
  map.put("client_home_category_business", Res.string.client_home_category_business)
  map.put("client_home_category_education", Res.string.client_home_category_education)
  map.put("client_home_category_events", Res.string.client_home_category_events)
  map.put("client_home_category_food", Res.string.client_home_category_food)
  map.put("client_home_category_health", Res.string.client_home_category_health)
  map.put("client_home_category_home", Res.string.client_home_category_home)
  map.put("client_home_category_household", Res.string.client_home_category_household)
  map.put("client_home_category_it_media", Res.string.client_home_category_it_media)
  map.put("client_home_category_logistics", Res.string.client_home_category_logistics)
  map.put("client_home_category_malls", Res.string.client_home_category_malls)
  map.put("client_home_category_markets", Res.string.client_home_category_markets)
  map.put("client_home_category_pets", Res.string.client_home_category_pets)
  map.put("client_home_category_travel", Res.string.client_home_category_travel)
  map.put("client_home_empty_description", Res.string.client_home_empty_description)
  map.put("client_home_empty_title", Res.string.client_home_empty_title)
  map.put("client_home_favorite_content_description", Res.string.client_home_favorite_content_description)
  map.put("client_home_filter_content_description", Res.string.client_home_filter_content_description)
  map.put("client_home_load_error_title", Res.string.client_home_load_error_title)
  map.put("client_home_location_city", Res.string.client_home_location_city)
  map.put("client_home_notifications_content_description", Res.string.client_home_notifications_content_description)
  map.put("client_home_search_placeholder", Res.string.client_home_search_placeholder)
  map.put("client_home_view_all", Res.string.client_home_view_all)
  map.put("client_location_search_back_content_description", Res.string.client_location_search_back_content_description)
  map.put("client_location_search_empty", Res.string.client_location_search_empty)
  map.put("client_location_search_placeholder", Res.string.client_location_search_placeholder)
  map.put("client_location_search_title", Res.string.client_location_search_title)
  map.put("client_map_empty_title", Res.string.client_map_empty_title)
  map.put("client_map_load_error", Res.string.client_map_load_error)
  map.put("client_map_loading", Res.string.client_map_loading)
  map.put("client_map_results_count", Res.string.client_map_results_count)
  map.put("client_map_search_placeholder", Res.string.client_map_search_placeholder)
  map.put("client_profile_app_version_prefix", Res.string.client_profile_app_version_prefix)
  map.put("client_profile_auth_required_message", Res.string.client_profile_auth_required_message)
  map.put("client_profile_auth_required_title", Res.string.client_profile_auth_required_title)
  map.put("client_profile_avatar_upload_error", Res.string.client_profile_avatar_upload_error)
  map.put("client_profile_change_photo", Res.string.client_profile_change_photo)
  map.put("client_profile_contact_description_label", Res.string.client_profile_contact_description_label)
  map.put("client_profile_contact_description_placeholder", Res.string.client_profile_contact_description_placeholder)
  map.put("client_profile_contact_error", Res.string.client_profile_contact_error)
  map.put("client_profile_contact_subject_label", Res.string.client_profile_contact_subject_label)
  map.put("client_profile_contact_subject_placeholder", Res.string.client_profile_contact_subject_placeholder)
  map.put("client_profile_contact_success", Res.string.client_profile_contact_success)
  map.put("client_profile_contact_us", Res.string.client_profile_contact_us)
}
